// List of AdAstra_05 voice lines (update this if new files are added)
const ADASTRA_05_VOICE_LINES = [
  '/audio/voice/AdAstra_05_Future-Analysis.mp3',
  '/audio/voice/AdAstra_05_Infinity-AdAstra.mp3',
  '/audio/voice/AdAstra_05_Insufficient-Attempts.mp3',
];
// List of AdAstra_04 voice lines (update this if new files are added)
const ADASTRA_04_VOICE_LINES = [
  '/audio/voice/AdAstra_04-First-Time.mp3',
  '/audio/voice/AdAstra_04_Embaressing.mp3',
  '/audio/voice/AdAstra_04_Like-That-But-Good.mp3',
  '/audio/voice/AdAstra_04_ReachStars.mp3',
  '/audio/voice/AdAstra_04_UTurn.mp3',
];
// List of AdAstra_03 voice lines (update this if new files are added)
const ADASTRA_03_VOICE_LINES = [
  '/audio/voice/AdAstra_03_Bulls-eye.mp3',
  '/audio/voice/AdAstra_03_I-Missed_it.mp3',
  '/audio/voice/AdAstra_03_ImpactConfirmed.mp3',
  '/audio/voice/AdAstra_03_NailedIt.mp3',
  '/audio/voice/AdAstra_03_WowMyHouse.mp3',
];
// List of AdAstra_02 voice lines (update this if new files are added)
const ADASTRA_02_VOICE_LINES = [
  '/audio/voice/AdAstra_02_BullByHorns.mp3',
  '/audio/voice/AdAstra_02_DramaticAlert.mp3',
  '/audio/voice/AdAstra_02_Gyroscopic-interpolators.mp3',
  '/audio/voice/AdAstra_02_HowHigh.mp3',
  '/audio/voice/AdAstra_02_Impossible-Necessary.mp3',
  '/audio/voice/AdAstra_02_InitiatingSelfDestruct.mp3',
  '/audio/voice/AdAstra_02_LandingProtocol.mp3',
  '/audio/voice/AdAstra_02_MissionSuccess.mp3',
  '/audio/voice/AdAstra_02_OxygenLevels.mp3',
  '/audio/voice/AdAstra_02_PowerSurge.mp3',
];
// List of AdAstra_01 voice lines (update this if new files are added)
const ADASTRA_01_VOICE_LINES = [
  '/audio/voice/AdAstra_01_Fuel-Levels.mp3',
  '/audio/voice/AdAstra_01_Hull-Integrity.mp3',
  '/audio/voice/AdAstra_01_Mission-AdAstra.mp3',
  '/audio/voice/AdAstra_01_Navigation-Systems-Offline.mp3',
];
// (moved into App below)
import React, { useEffect, useRef, useState, memo } from 'react';
import * as THREE from 'three';
import { Canvas, useThree, useFrame } from '@react-three/fiber';
import { Environment, Html, Preload } from '@react-three/drei';
import { EffectComposer, Bloom } from '@react-three/postprocessing';
import { KernelSize, Resolution } from 'postprocessing'
import { Perf } from 'r3f-perf'

import { LanguageProvider, useLanguage } from './i18n/useLanguage.jsx';
import StoryBox from './components/StoryBox';
import PostPreviewDownload from './components/LinkedInShareButton';
import SimpleLensFlare from './components/SimpleLensFlare';
import PlayButton from './components/PlayButton';
import UserDataForm from './components/UserDataForm';
import LanguageSelector from './components/LanguageSelector';
import AdminPanel from './components/AdminPanel';
import RocketShip from './components/RocketShip';
import Cake from './components/Cake';
import CakeHitParticles from './components/CakeHitParticles';
import ChargeBar from './components/ChargeBar';
import RotateDeviceOverlay from './components/RotateDeviceOverlay';
import SpaceComm from './components/spacecomm/SpaceComm';
import { WebAudioPlayer } from './utils/WebAudioPlayer';
import { track } from '@vercel/analytics';


// Global WebAudioPlayer instance for all app audio
const webAudioPlayer = new WebAudioPlayer();
const audioCache = {}; // For preloading only
async function playAudio(src, opts = {}) {
  return webAudioPlayer.play(src, opts);
}
function preloadAudio(src) {
  if (!audioCache[src]) {
    // Preload buffer via WebAudioPlayer
    webAudioPlayer.loadBuffer(src);
    audioCache[src] = true;
  }
}

// Global variable to track successful cake hits
let totalCakeHits = 0;
let totalAttempts = 0;

function getRandomEmissiveColor() {
  // Return a random bright color as [r, g, b] in 0-1 range
  const h = Math.random();
  const s = 0.7 + Math.random() * 0.3;
  const v = 0.7 + Math.random() * 0.3;
  // Convert HSV to RGB
  const i = Math.floor(h * 6);
  const f = h * 6 - i;
  const p = v * (1 - s);
  const q = v * (1 - f * s);
  const t = v * (1 - (1 - f) * s);
  let r, g, b;
  switch (i % 6) {
    case 0: r = v; g = t; b = p; break;
    case 1: r = q; g = v; b = p; break;
    case 2: r = p; g = v; b = t; break;
    case 3: r = p; g = q; b = v; break;
    case 4: r = t; g = p; b = v; break;
    case 5: r = v; g = p; b = q; break;
  }
  return [r, g, b];
}


const HDRI_VARIANTS = [
  {
    folder: 'open-space',
    files: [
      '/hdri/open-space/Space.webp',
      '/hdri/open-space/Space-gainmap.webp',
      '/hdri/open-space/Space.json',
    ],
  },
  {
    folder: 'dead-planet',
    files: [
      '/hdri/dead-planet/the-dead-planet.webp',
      '/hdri/dead-planet/the-dead-planet-gainmap.webp',
      '/hdri/dead-planet/the-dead-planet.json',
    ],
  },
  {
    folder: 'devoure-planet',
    files: [
      '/hdri/devoure-planet/the-devoure-planet.webp',
      '/hdri/devoure-planet/the-devoure-planet-gainmap.webp',
      '/hdri/devoure-planet/the-devoure-planet.json',
    ],
  },
  {
    folder: 'sci-fi-planet',
    files: [
      '/hdri/sci-fi-planet/sci-fi-planet.webp',
      '/hdri/sci-fi-planet/sci-fi-planet-gainmap.webp',
      '/hdri/sci-fi-planet/sci-fi-planet.json',
    ],
  },
  {
    folder: 'volcanic_Planet',
    files: [
      '/hdri/volcanic_Planet/volcanic-planet.webp',
      '/hdri/volcanic_Planet/volcanic-planet-gainmap.webp',
      '/hdri/volcanic_Planet/volcanic-planet.json',
    ],
  },
];

const EnvironmentAndStars = memo(function EnvironmentAndStars({ emissiveColor, hdriFiles }) {
  const groupRef = useRef();
  const [envRotation, setEnvRotation] = useState({ y: 0, z: 0 });
  useFrame(() => {
    if (groupRef.current) {
      groupRef.current.rotation.z += 0.001;
      setEnvRotation(r => ({
        y: r.y + 0.001,
        z: r.z + 0.001
      }));
    }
  });
  return (
    <group ref={groupRef}>
      <Environment
        files={hdriFiles}
        background
        backgroundIntensity={1}
        environmentIntensity={1}
        backgroundRotation={[envRotation.y, envRotation.y, 0]}
      />
      <SimpleLensFlare position={[20, 5, -20]} size={50} emissiveColor={emissiveColor} />
    </group>
  );
});

// DirectionalLight Helper Component
function DirectionalLightHelper({ dirLightRef }) {
  const { scene } = useThree();
  const helperRef = useRef();
  const shadowCameraHelperRef = useRef();

  useEffect(() => {
    if (dirLightRef.current && !helperRef.current) {
      // Light direction helper
      const helper = new THREE.DirectionalLightHelper(dirLightRef.current, 5);
      helperRef.current = helper;
      scene.add(helper);

      // Shadow camera helper to visualize the shadow frustum
      const shadowCameraHelper = new THREE.CameraHelper(dirLightRef.current.shadow.camera);
      shadowCameraHelperRef.current = shadowCameraHelper;
      scene.add(shadowCameraHelper);
    }

    return () => {
      if (helperRef.current) {
        scene.remove(helperRef.current);
        helperRef.current = null;
      }
      if (shadowCameraHelperRef.current) {
        scene.remove(shadowCameraHelperRef.current);
        shadowCameraHelperRef.current = null;
      }
    };
  }, [dirLightRef, scene]);

  return null;
}

export default function App() {
  return (
    <LanguageProvider>
      <GameComponent />
    </LanguageProvider>
  );
}

function GameComponent() {
  // Language hook for translations
  const { t, currentLanguage, changeLanguage } = useLanguage();

  // All state declarations first
  const [showLaunchMenu, setShowLaunchMenu] = useState(true);
  const [showUserDataForm, setShowUserDataForm] = useState(false);
  const [showStoryBox, setShowStoryBox] = useState(false);
  const [sceneStarted, setSceneStarted] = useState(false);
  const [gameStarted, setGameStarted] = useState(false);
  const [hits, setHits] = useState(0);
  const [rocketFiring, setRocketFiring] = useState(false);
  const [gameComplete, setGameComplete] = useState(false);
  const [rotationIntensity, setRotationIntensity] = useState(2);
  const [resetCounter, setResetCounter] = useState(0);
  const [showRetryPrompt, setShowRetryPrompt] = useState(false);
  const [attempts, setAttempts] = useState(0);
  const [curveSeed, setCurveSeed] = useState(() => Math.floor(Math.random() * 1e9));
  const [showCakeParticles, setShowCakeParticles] = useState(false);
  const [hasZoomed, setHasZoomed] = useState(false);
  const [forceFovReset, setForceFovReset] = useState(false);
  const [fail, setFail] = useState(false);
  const [maxAttempts] = useState(5);
  const [userData, setUserData] = useState(null); // Store user data from post-game form
  const [firebaseDocId, setFirebaseDocId] = useState(null); // Store Firebase document ID for tracking
  const [gameNumber, setGameNumber] = useState(1); // Track number of times user plays to completion
  const [sessionScore, setSessionScore] = useState(0); // Cumulative score across all games in session
  const [sessionMisses, setSessionMisses] = useState(0); // Cumulative misses across all games in session
  const [formCompletedThisGame, setFormCompletedThisGame] = useState(false); // Track if form was completed for current game
  const cakeRef = useRef()
  const rocketRef = useRef()
  
  // Check if admin panel should be shown
  const showAdminPanel = new URLSearchParams(window.location.search).get('admin') === 'true';
  
  // Check if sc mode is enabled (triggered by ?sc=true)
  const isScMode = new URLSearchParams(window.location.search).get('sc') === 'true';
  
  const [emissiveColor, setEmissiveColor] = useState(getRandomEmissiveColor());
  const [isChargeBarVisible, setIsChargeBarVisible] = useState(false);
  const isChargeBarVisibleRef = useRef(isChargeBarVisible);
  const showStoryBoxRef = useRef(showStoryBox);

  useEffect(() => { isChargeBarVisibleRef.current = isChargeBarVisible; }, [isChargeBarVisible]);
  useEffect(() => { showStoryBoxRef.current = showStoryBox; }, [showStoryBox]);

  // Add sc-mode class to body when in sc mode
  useEffect(() => {
    if (isScMode) {
      document.body.classList.add('sc-mode');
    } else {
      document.body.classList.remove('sc-mode');
    }
  }, [isScMode]);

  // Manage body class for hiding UI background bars when cake is hit (based on showCakeParticles)
  useEffect(() => {
    // Direct DOM manipulation approach
    const topBar = document.querySelector('.ui-background-bar-top');
    const bottomBar = document.querySelector('.ui-background-bar-bottom');
    
    if (showCakeParticles) {
      document.body.classList.add('hide-ui-bars');
      // Force hide with direct style
      if (topBar) topBar.style.display = 'none';
      if (bottomBar) bottomBar.style.display = 'none';
    } else {
      document.body.classList.remove('hide-ui-bars');
      // Restore display
      if (topBar) topBar.style.display = '';
      if (bottomBar) bottomBar.style.display = '';
    }
    
    // Cleanup on unmount
    return () => {
      document.body.classList.remove('hide-ui-bars');
      if (topBar) topBar.style.display = '';
      if (bottomBar) bottomBar.style.display = '';
    };
  }, [showCakeParticles]);

  useEffect(() => {
    setIsChargeBarVisible(
      sceneStarted &&
      !showStoryBox &&
      !gameComplete &&
      !showRetryPrompt
    );
  }, [sceneStarted, showStoryBox, gameComplete, showRetryPrompt]);


  const ai02VoicesRef = useRef([]);
  const ai02IntervalRef = useRef(null);
  const ai03VoiceRef = useRef(null);
  const ai04VoiceRef = useRef(null);
  const ai05VoiceRef = useRef(null);

  // Play a random AdAstra_05 voice line when 'You Reached Level' UI is visible, stop when hidden
  useEffect(() => {
    const reachedLevelUIVisible = showRetryPrompt && attempts >= maxAttempts;
    if (reachedLevelUIVisible) {
      const idx = Math.floor(Math.random() * ADASTRA_05_VOICE_LINES.length);
      const src = ADASTRA_05_VOICE_LINES[idx];
      playAudio(src, { volume: 1 }).then(({ source, gain }) => {
        ai05VoiceRef.current = { source, gain, src };
      });
    } else {
      if (ai05VoiceRef.current) {
        try { ai05VoiceRef.current.source.stop(); } catch (e) {}
        ai05VoiceRef.current = null;
      }
    }
  }, [showRetryPrompt, attempts]);


  useEffect(() => {
    const missedUIVisible = showRetryPrompt && attempts < maxAttempts;
    if (missedUIVisible) {
      const idx = Math.floor(Math.random() * ADASTRA_04_VOICE_LINES.length);
      const src = ADASTRA_04_VOICE_LINES[idx];
      playAudio(src, { volume: 1 }).then(({ source, gain }) => {
        ai04VoiceRef.current = { source, gain, src };
      });
    } else {
      if (ai04VoiceRef.current) {
        try { ai04VoiceRef.current.source.stop(); } catch (e) {}
        ai04VoiceRef.current = null;
      }
    }
  }, [showRetryPrompt, attempts, maxAttempts]);



  // Play a random AdAstra_03 voice line when level complete UI is visible, stop when hidden
  useEffect(() => {
    const levelCompleteVisible = gameComplete && !showRetryPrompt && hasZoomed;
    if (levelCompleteVisible) {
      const idx = Math.floor(Math.random() * ADASTRA_03_VOICE_LINES.length);
      const src = ADASTRA_03_VOICE_LINES[idx];
      playAudio(src, { volume: 1 }).then(({ source, gain }) => {
        ai03VoiceRef.current = { source, gain, src };
      });
    } else {
      if (ai03VoiceRef.current) {
        try { ai03VoiceRef.current.source.stop(); } catch (e) {}
        ai03VoiceRef.current = null;
      }
    }
  }, [gameComplete, showRetryPrompt, hasZoomed]);

  // Helper to manage ai_02 audio interval and playback
  function manageAi02Audio(shouldPlay) {
    // Stop all ai_02 voices and interval first
    if (ai02IntervalRef.current) {
      clearInterval(ai02IntervalRef.current);
      ai02IntervalRef.current = null;
    }
    ai02VoicesRef.current.forEach(obj => { try { obj.source.stop(); } catch (e) {} });
    ai02VoicesRef.current = [];
    if (shouldPlay) {
      const playRandomAi02 = () => {
        const idx = Math.floor(Math.random() * ADASTRA_02_VOICE_LINES.length);
        const src = ADASTRA_02_VOICE_LINES[idx];
        playAudio(src, { volume: 1 }).then(({ source, gain }) => {
          ai02VoicesRef.current.push({ source, gain, src });
        });
      };
      playRandomAi02();
      ai02IntervalRef.current = setInterval(playRandomAi02, 10000);
    }
  }

  // Play a random ai__02 voice line every 10s when ChargeBar is visible, stop when hidden
  useEffect(() => {
    manageAi02Audio(isChargeBarVisible && !showStoryBox);
    return () => {
      manageAi02Audio(false);
    };
  }, [isChargeBarVisible, showStoryBox]);

  // Ref to track the currently playing ai__01 voice line
  const ai01VoiceRef = useRef(null);
  // Play a random AdAstra_01 voice line when StoryBox is shown, stop when hidden
  useEffect(() => {
    if (showStoryBox) {
      // Pick a random AdAstra_01 voice line
      const idx = Math.floor(Math.random() * ADASTRA_01_VOICE_LINES.length);
      const src = ADASTRA_01_VOICE_LINES[idx];
      playAudio(src, { volume: 1 }).then(({ source, gain }) => {
        ai01VoiceRef.current = { source, gain, src };
      });
    } else {
      // Pause/stop any currently playing ai__01 voice line
      if (ai01VoiceRef.current) {
        try { ai01VoiceRef.current.source.stop(); } catch (e) {}
        ai01VoiceRef.current = null;
      }
    }
  }, [showStoryBox]);
  
  const getRandomHdriFiles = (current = null) => {
    let options = HDRI_VARIANTS;
    if (current) {
      options = HDRI_VARIANTS.filter(v => v.files[0] !== current[0]);
      if (options.length === 0) options = HDRI_VARIANTS; // fallback if only one
    }
    const idx = Math.floor(Math.random() * options.length);
    return options[idx].files;
  };
  const [hdriFiles, setHdriFiles] = useState(() => getRandomHdriFiles());


useEffect(() => {
  function pauseAllAudio() {
    // Stop all HTMLAudioElements (legacy, just in case)
    document.querySelectorAll('audio').forEach(a => { try { a.pause(); } catch (e) {} });
    // Stop WebAudioPlayer music/alarms
    if (gameSongRef && gameSongRef.current && gameSongRef.current.source) {
      try { gameSongRef.current.source.stop(); } catch (e) {}
    }
    if (alarmAudioRef && alarmAudioRef.current && alarmAudioRef.current.source) {
      try { alarmAudioRef.current.source.stop(); } catch (e) {}
    }
    // Stop all ai_02 voices and clear interval
    if (ai02IntervalRef && ai02IntervalRef.current) {
      clearInterval(ai02IntervalRef.current);
      ai02IntervalRef.current = null;
    }
    if (ai02VoicesRef && ai02VoicesRef.current) {
      ai02VoicesRef.current.forEach(obj => { try { obj.source.stop(); } catch (e) {} });
      ai02VoicesRef.current = [];
    }
  }
  function resumeAudio() {
    // Resume only if they should be playing (replay background music if needed)
    if (gameSongRef && gameSongRef.current && ((!showRetryPrompt && !gameComplete && !showLaunchMenu) || showStoryBoxRef.current)) {
      playAudio('/audio/sfx/GameSong_01.mp3', { volume: 0.15, loop: true }).then(({ source, gain }) => {
        gameSongRef.current = { source, gain };
      });
    }
    // Alarm audio is now managed only by useEffect([showStoryBox])

    // Resume ai_02 audio if charge bar is visible and story box is not (using refs for latest values)
    manageAi02Audio(isChargeBarVisibleRef.current && !showStoryBoxRef.current);
  }
  window.addEventListener('blur', pauseAllAudio);
  window.addEventListener('focus', resumeAudio);
  return () => {
    window.removeEventListener('blur', pauseAllAudio);
    window.removeEventListener('focus', resumeAudio);
  };
}, [showRetryPrompt, gameComplete, showLaunchMenu, showStoryBox]);

  // Alarm audio ref
  const alarmAudioRef = useRef(null);
  // Play/pause alarm sound when StoryBox is visible
  useEffect(() => {
    if (!alarmAudioRef.current) {
      alarmAudioRef.current = { source: null, gain: null };
    }
    if (showStoryBox) {
      if (alarmAudioRef.current.source) {
        try { alarmAudioRef.current.source.stop(); } catch (e) {}
      }
      playAudio('/audio/sfx/Alarm_01.mp3', { volume: 0.5, loop: true }).then(({ source, gain }) => {
        alarmAudioRef.current = { source, gain };
      });
    } else {
      if (alarmAudioRef.current && alarmAudioRef.current.source) {
        try { alarmAudioRef.current.source.stop(); } catch (e) {}
        alarmAudioRef.current = { source: null, gain: null };
      }
    }
  }, [showStoryBox]);


  // Background music audio ref
  const gameSongRef = useRef(null);
  // Play/pause background music based on UI state
  useEffect(() => {
    if (!gameSongRef.current) {
      gameSongRef.current = { source: null, gain: null };
    }
    if ((!showRetryPrompt && !gameComplete && !showLaunchMenu) || showStoryBox) {
      if (gameSongRef.current.source) {
        try { gameSongRef.current.source.stop(); } catch (e) {}
      }
      playAudio('/audio/sfx/GameSong_01.mp3', { volume: 0.15, loop: true }).then(({ source, gain }) => {
        gameSongRef.current = { source, gain };
      });
    } else {
      if (gameSongRef.current && gameSongRef.current.source) {
        try { gameSongRef.current.source.stop(); } catch (e) {}
        gameSongRef.current = { source: null, gain: null };
      }
    }
  }, [showRetryPrompt, gameComplete, showLaunchMenu, showStoryBox]);


  // Reset game state (for off-target shots)
  const resetGame = () => {
    setShowRetryPrompt(false);
    setForceFovReset(true); // Trigger FOV reset
    setTimeout(() => {
      setRocketFiring(false); // Do not set to true after reset
      setGameComplete(false);
      setRotationIntensity(2);
      setResetCounter(c => c + 1);
      // Do NOT increment attempts here; only increment on charge release
      setCurveSeed(Math.floor(Math.random() * 1e9));
    }, 0);
  }

  const handleMiss = () => {
    // Only show retry prompt after animation completes (i.e., after miss)
    setTimeout(() => {
      setShowRetryPrompt(true);
    }, 0);
  }

  // Called by ChargeBar every frame with info about fill and marker
  const handleFloatRotation = ({ rotationIntensity, fireDirection }) => {
    setRotationIntensity(rotationIntensity)
    if (fireDirection) {
      // Fire in the direction the rocket is facing at this instant (miss only)
      if (rocketRef.current && rocketRef.current.getWorldQuaternion) {
        const quat = rocketRef.current.getWorldQuaternion();
        if (quat) {
          const localForward = new THREE.Vector3(0, 1, 0);
          localForward.applyQuaternion(quat);
          localForward.normalize();
          const norm = [localForward.x, localForward.y, localForward.z];
          setRocketFiring(norm); // Always a vector, never true
          return;
        }
      }
      setRocketFiring([0,0,-1]);
    }
  }

  // Prevent further attempts if maxAttempts reached
  const canAttempt = attempts < maxAttempts;


  // On hit, fire the rocket (animation), but don't set gameComplete yet
  const handleTargetHit = () => {
    setRocketFiring(true);
    setFail(false); // Not a fail
    // Do not emit particles yet; wait for animation complete
  };
  // Called when the user fails the charge (not in target area)
  const handleFailCharge = () => {
    setFail(true);
    setRocketFiring(true);
  };


  // Called by RocketShip when animation to cake is done
  const handleHitAnimationComplete = () => {
    setGameComplete(true);
    setShowCakeParticles(true); // Emit particles only after hit animation completes
    // Play random cake hit sound at the same time as cake model switches
    const which = Math.random() < 0.5 ? '01' : '02';
  playAudio(`/audio/sfx/CakeHit_${which}.mp3`, { volume: 0.5 });
    setHasZoomed(false); // Reset zoom state for next round only when starting a new round
    totalCakeHits += 1; // Increment global hit counter
    setHits(totalCakeHits); // Force re-render so markerSpeed and UI update

  };

  const handlePlayAgain = (resetHits = false) => {
    setShowRetryPrompt(false);
    setHasZoomed(false); // Reset zoom state for next round
    setForceFovReset(true); // Trigger FOV reset
    setShowCakeParticles(false); // Despawn cake particles
    // Note: gameNumber is now only incremented from the final "Play Again" button, not here
    if (resetHits) {
      setHits(0);
      totalCakeHits = 0;
      totalAttempts = 0;
    }
    setEmissiveColor(getRandomEmissiveColor()); // Randomize lens flare color for new run
  setHdriFiles(prev => getRandomHdriFiles(prev)); // Randomize HDRI for new run, always different
    setTimeout(() => {
      setRocketFiring(false);
      setGameComplete(false);
      setRotationIntensity(2);
      setResetCounter(c => c + 1);
      setAttempts(0); // Reset attempts on play again
      setCurveSeed(Math.floor(Math.random() * 1e9));
    }, 0);
  };


  const dirLightRef = useRef();
  // Show StoryBox only after scene has started rendering and LaunchMenu is dismissed
  React.useEffect(() => {
    if (sceneStarted && !showLaunchMenu) {
      setShowStoryBox(true);
    }
  }, [sceneStarted, showLaunchMenu]);

  // Preload all audio files on app mount to ensure instant playback, especially on mobile.
  useEffect(() => {
    // List all audio file paths to preload
    const audioFiles = [
      '/audio/sfx/GameSong_01.mp3',
      '/audio/sfx/Alarm_01.mp3',
      '/audio/sfx/Ding_Start.mp3',
      '/audio/sfx/Engine_Charge_01.mp3',
      '/audio/sfx/Engine_Blast_01.mp3',
      '/audio/sfx/Engine_Blast_02.mp3',
      '/audio/sfx/CakeHit_01.mp3',
      '/audio/sfx/CakeHit_02.mp3',
      '/audio/sfx/UI_Buttons_01.mp3',
      '/audio/sfx/UI_Buttons_02.mp3',
      '/audio/sfx/UI_FailedMission_01.mp3',
      '/audio/sfx/UI_FailedMission_02.mp3',
      '/audio/sfx/UI_MissionSuccess_01.mp3',
      '/audio/sfx/Sparks_01.mp3',
      '/audio/sfx/Sparks_02.mp3',
      '/audio/sfx/Sparks_03.mp3',
      // Voice lines (add all .mp3 files from public/audio/voice)
      '/audio/voice/AdAstra_05_Future-Analysis.mp3',
      '/audio/voice/AdAstra_05_Infinity-AdAstra.mp3',
      '/audio/voice/AdAstra_05_Insufficient-Attempts.mp3',
      '/audio/voice/AdAstra_04-First-Time.mp3',
      '/audio/voice/AdAstra_04_Embaressing.mp3',
      '/audio/voice/AdAstra_04_Like-That-But-Good.mp3',
      '/audio/voice/AdAstra_04_ReachStars.mp3',
      '/audio/voice/AdAstra_04_UTurn.mp3',
      '/audio/voice/AdAstra_03_Bulls-eye.mp3',
      '/audio/voice/AdAstra_03_I-Missed_it.mp3',
      '/audio/voice/AdAstra_03_ImpactConfirmed.mp3',
      '/audio/voice/AdAstra_03_NailedIt.mp3',
      '/audio/voice/AdAstra_03_WowMyHouse.mp3',
      '/audio/voice/AdAstra_02_BullByHorns.mp3',
      '/audio/voice/AdAstra_02_DramaticAlert.mp3',
      '/audio/voice/AdAstra_02_Gyroscopic-interpolators.mp3',
      '/audio/voice/AdAstra_02_HowHigh.mp3',
      '/audio/voice/AdAstra_02_Impossible-Necessary.mp3',
      '/audio/voice/AdAstra_02_InitiatingSelfDestruct.mp3',
      '/audio/voice/AdAstra_02_LandingProtocol.mp3',
      '/audio/voice/AdAstra_02_MissionSuccess.mp3',
      '/audio/voice/AdAstra_02_OxygenLevels.mp3',
      '/audio/voice/AdAstra_02_PowerSurge.mp3',
      '/audio/voice/AdAstra_01_Fuel-Levels.mp3',
      '/audio/voice/AdAstra_01_Hull-Integrity.mp3',
      '/audio/voice/AdAstra_01_Mission-AdAstra.mp3',
      '/audio/voice/AdAstra_01_Navigation-Systems-Offline.mp3',
      // ...add all other voice .mp3 files here as needed
    ];
    // Preload each file
    audioFiles.forEach(src => {
  preloadAudio(src);
    });
  }, []);

  return (
    <>
      {/* Language Selector - hide after launch menu */}
      {showLaunchMenu && <LanguageSelector />}
      
      {/* Admin Panel - only show when ?admin=true in URL */}
      {showAdminPanel && <AdminPanel />}
      
      {/* UI Background Bars */}
      <div className="ui-background-bar-top"></div>
      <div className="ui-background-bar-bottom"></div>
    
      <RotateDeviceOverlay />
      {showLaunchMenu && (
        <div style={{ position: 'fixed', zIndex: 3000, left: 0, top: 0, width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.85)' }}>
          <PlayButton 
            translationFunction={t}
            isScMode={isScMode}
            onPlay={() => {
              setShowLaunchMenu(false);
            }} 
          />
        </div>
      )}
      {!showLaunchMenu && (
        <>
          {/* StoryBox overlays gameplay if visible */}
          {showStoryBox && sceneStarted && (
            <StoryBox onContinue={async () => {
              playUIButtonSound();
              // Play Ding_Start.mp3 only when user presses continue
              playAudio('/audio/sfx/Ding_Start.mp3', { volume: 0.25 });
              setShowStoryBox(false);
              setGameStarted(true);
              
              // Track game start only for the first game
              if (gameNumber === 1 && !firebaseDocId) {
                try {
                  const { trackGameStart } = await import('./utils/firebaseSubmission');
                  const docId = await trackGameStart(1, null, currentLanguage);
                  setFirebaseDocId(docId);
                } catch (error) {
                  console.error('Failed to track game start:', error);
                }
              }
            }} />
          )}
          <Canvas dpr={[1,2]} camera={{ position: [0, 0, 0], fov: 75 }} shadows onCreated={() => setSceneStarted(true)}>
            
            {/* Performance monitoring - show when ?states=true in URL */}
            {new URLSearchParams(window.location.search).get('stats') === 'true' && <Perf position="top-left" />}

            <EnvironmentAndStars emissiveColor={emissiveColor} hdriFiles={hdriFiles} />
            {/* Lighting */}
            <ambientLight intensity={1} />
            <directionalLight
              ref={dirLightRef}
              position={[10, 10, 5]}
              intensity={10}
              castShadow
              shadow-mapSize-width={2048}
              shadow-mapSize-height={2048}
              shadow-camera-near={0}
              shadow-camera-far={50}
              shadow-camera-left={-18}
              shadow-camera-right={18}
              shadow-camera-top={18}
              shadow-camera-bottom={-18}
              shadow-bias={-0.001}
            />
            {/* <DirectionalLightHelper dirLightRef={dirLightRef} /> */}
            {/* Rocket Ship - positioned below camera and facing away */}
            {/* Only render RocketShip independently if not stuck in cake */}
            {!showRetryPrompt && !gameComplete && (
              <>
                <RocketShip 
                  ref={rocketRef}
                  position={[0, -2, -5]} 
                  rotation={[-Math.PI / 2, 0, 0]} 
                  firing={rocketFiring}
                  targetPosition={[0, 0, -20]}
                  cakeRef={cakeRef}
                  floatRotationIntensity={rotationIntensity}
                  resetGame={resetGame}
                  resetCounter={resetCounter}
                  onMiss={handleMiss}
                  paused={false}
                  gameComplete={gameComplete}
                  onHitAnimationComplete={handleHitAnimationComplete}
                  curveSeed={curveSeed}
                  fail={fail}
                />
              </>
            )}
            {/* Cake - floating in space and always facing camera, attaches rocket when gameComplete */}
            <Cake position={[0, 0, -20]} ref={cakeRef} showStuckRocket={gameComplete} />
            {/* Cake hit particles: emit when rocket hits cake */}
            <CakeHitParticles emit={showCakeParticles} origin={[0, 0, -18]} count={100} />
            {/* Charge Bar - bottom right screen overlay */}
            {/* Hide ChargeBar until scene is started and StoryBox is dismissed, and disable if max attempts reached */}
            {sceneStarted && !showStoryBox && (
              <ChargeBar
                onTargetHit={handleTargetHit}
                disabled={gameComplete || !canAttempt}
                onFloatRotation={handleFloatRotation}
                resetCounter={resetCounter}
                onChargeRelease={() => {
                  if (canAttempt) {
                    setAttempts(a => a + 1);
                    totalAttempts += 1;
                  }
                }}
                markerSpeed={Math.max(2 * Math.pow(0.8, hits), 0.1)}
                onFailCharge={handleFailCharge}
              />
            )}
            {/* Attempts Remaining Overlay (top of screen, styled consistently) */}
            {/* Desktop: Level bottom left, attempts top right. Mobile: Level top left, attempts top right. */}
            {!gameComplete && sceneStarted && !showStoryBox && !(showRetryPrompt && attempts >= maxAttempts) && (
              <>
                {/* Desktop only: DSL logo top left */}
                <Html style={{ pointerEvents: 'auto', zIndex: 5000 }}>
                  <a
                    href={isScMode ? undefined : "https://www.pldspace.com/"}
                    target={isScMode ? undefined : "_blank"}
                    rel="noopener noreferrer"
                    className="dsl-logo-desktop"
                    onClick={isScMode ? undefined : () => track('CLICK_PLD_LOGO_DESKTOP')}
                    style={isScMode ? { pointerEvents: 'none' } : undefined}
                  >
                    <img
                      src="/images/PLDSpace_Logo_White.svg"
                      alt="DSL Logo"
                      className="dsl-logo-img-desktop"
                    />
                  </a>
                </Html>
                {/* Desktop only */}
                <Html style={{ pointerEvents: 'none', zIndex: 4000 }}>
                  <div className="ui-level-indicator-desktop mobile-font-reduce">
                    <div className="ui-level-counter">{t('gameUI.level')} <span className="level-number">{hits + 1}</span></div>
                  </div>
                </Html>
                {/* Dark Star Labs Attribution */}
                <Html style={{ pointerEvents: 'none', zIndex: 4000 }}>
                  <div className="dsl-attribution">
                    <a
                      href={isScMode ? undefined : "https://www.darkstarlabs.io/"}
                      target={isScMode ? undefined : "_blank"}
                      rel="noopener noreferrer"
                      onClick={isScMode ? undefined : () => track('CLICK_DARK_STAR_LABS')}
                      style={isScMode ? { pointerEvents: 'none' } : undefined}
                    >
                      <div className="powered-by-text">Powered by</div>
                      <div className="dark-star-labs-text">DARK STAR <span className="labs-red">LABS</span></div>
                    </a>
                  </div>
                </Html>
                <Html style={{ pointerEvents: 'none', zIndex: 4000 }}>
                  <div className="ui-attempts-indicator-desktop mobile-font-reduce">
                    <div className="ui-attempts fuel-cells-label-wrap">
                      <span className="fuel-cells-label-full">{t('gameUI.fuelRemaining')}</span>
                      <span className="fuel-cells-label-short">{t('gameUI.fuelRemainingShort')}</span>
                      <span className="fuel-cells-squares">
                        {Array.from({ length: maxAttempts - attempts }).map((_, i) => (
                          <span key={i} className="fuel-cell-square" />
                        ))}
                      </span>
                    </div>
                  </div>
                </Html>
                {/* Mobile only */}
                <Html style={{ pointerEvents: 'none', zIndex: 4000 }}>
                  <div className="ui-level-indicator-mobile mobile-font-reduce">
                    <div className="ui-level-counter">{t('gameUI.level')} <span className="level-number">{hits + 1}</span></div>
                  </div>
                </Html>
                <Html style={{ pointerEvents: 'none', zIndex: 4000 }}>
                  <div className="ui-attempts-indicator-mobile mobile-font-reduce">
                    <div className="ui-attempts fuel-cells-label-wrap">
                      <span className="fuel-cells-label-full">{t('gameUI.fuelRemaining')}:</span>
                      <span className="fuel-cells-label-short">{t('gameUI.fuelRemainingShort')}</span>
                      <span className="fuel-cells-squares">
                        {Array.from({ length: maxAttempts - attempts }).map((_, i) => (
                          <span key={i} className="fuel-cell-square" />
                        ))}
                      </span>
                    </div>
                  </div>
                </Html>
              </>
            )}
            {/* Retry Prompt Overlay or Mission Failed UI */}
            {showRetryPrompt && attempts < maxAttempts && (
              (() => {
                // Play failed mission sound when missed UI is displayed
                if (!window._failedMissionPlayed) {
                  const which = Math.random() < 0.5 ? '01' : '02';
                  playAudio(`/audio/sfx/UI_FailedMission_${which}.mp3`, { volume: 0.25 });
                  window._failedMissionPlayed = true;
                }
                return (
                  <Html center style={{ zIndex: 1000 }}>
                    <div className="ui-overlay retry mobile-font-reduce">
                      <div className="ui-retry-title">{t('gameUI.youMissed')}</div>
                      <button className="ui-congrats-btn" onClick={async () => { 
                        playUIButtonSound(); 
                        
                        // Track current progress before retrying
                        if (firebaseDocId) {
                          try {
                            const { trackLevelCompletion } = await import('./utils/firebaseSubmission');
                            // Calculate current session totals
                            const currentSessionScore = sessionScore + (hits + 1);
                            const currentSessionMisses = sessionMisses + (totalAttempts - totalCakeHits);
                            await trackLevelCompletion(
                              firebaseDocId, 
                              gameNumber, 
                              hits + 1, 
                              totalAttempts - totalCakeHits,
                              currentSessionScore,
                              currentSessionMisses
                            );
                          } catch (error) {
                            console.error('Failed to track progress on retry:', error);
                          }
                        }
                        
                        resetGame(); 
                        window._failedMissionPlayed = false; 
                        track('TRY_AGAIN');
                      }}>{t('gameUI.tryAgain')}</button>
                    </div>
                  </Html>
                );
              })()
            )}
            {/* Logo and Attribution for You Missed Screen */}
            {showRetryPrompt && attempts < maxAttempts && (
              <>
                {/* PLD Space Logo - Top Left */}
                <Html style={{ pointerEvents: 'auto', zIndex: 10000 }}>
                  <a
                    href={isScMode ? undefined : "https://www.pldspace.com/"}
                    target={isScMode ? undefined : "_blank"}
                    rel="noopener noreferrer"
                    className="dsl-logo-desktop"
                    onClick={isScMode ? undefined : () => track('CLICK_PLD_LOGO_DESKTOP')}
                    style={isScMode ? { pointerEvents: 'none' } : undefined}
                  >
                    <img
                      src="/images/PLDSpace_Logo_White.svg"
                      alt="PLD Space Logo"
                      className="dsl-logo-img-desktop"
                    />
                  </a>
                </Html>
                {/* Dark Star Labs Attribution - Bottom Left (Desktop) / Bottom Center (Mobile) */}
                <Html style={{ pointerEvents: 'auto', zIndex: 10000 }}>
                  <div className="dsl-attribution dsl-attribution-score-preview-mobile">
                    <a
                      href={isScMode ? undefined : "https://www.darkstarlabs.io/"}
                      target={isScMode ? undefined : "_blank"}
                      rel="noopener noreferrer"
                      onClick={isScMode ? undefined : () => track('CLICK_DARK_STAR_LABS')}
                      style={isScMode ? { pointerEvents: 'none' } : undefined}
                    >
                      <div className="powered-by-text">Powered by</div>
                      <div className="dark-star-labs-text">DARK STAR <span className="labs-red">LABS</span></div>
                    </a>
                  </div>
                </Html>
              </>
            )}
            {showRetryPrompt && attempts >= maxAttempts && !showUserDataForm && (
              (() => {
                // Play failed mission sound when end mission UI is displayed
                if (!window._failedMissionPlayed) {
                  const which = Math.random() < 0.5 ? '01' : '02';
                  playAudio(`/audio/sfx/UI_FailedMission_${which}.mp3`, { volume: 0.25 });
                  window._failedMissionPlayed = true;
                }
                // Track REACHED_LEVEL_[Level Number] when finish screen is shown
                if (!window._reachedLevelTracked) {
                  track(`REACHED_LEVEL_${hits + 1}`);
                  window._reachedLevelTracked = true;
                }
                // Show user data collection form if not completed for this game
                if (!formCompletedThisGame) {
                  setShowUserDataForm(true);
                  return null; // Don't render anything here, let the form handle it
                } else {
                  // Show final score if user data already collected for this game
                  return (
                    <Html center style={{ zIndex: 3000 }}>
                      <div className="ui-overlay congrats full-height-reached-level mobile-font-reduce fade-in">
                        <PostPreviewDownload
                          level={hits + 1}
                          misses={totalAttempts - totalCakeHits}
                          playerName={userData?.userName}
                          questionAnswer={userData?.questionAnswer}
                          firebaseDocId={firebaseDocId}
                          gameNumber={gameNumber}
                          currentLanguage={currentLanguage}
                          translationFunction={t}
                          onPlayAgain={async () => { 
                            playUIButtonSound(); 
                            
                            // Increment game number for next complete playthrough
                            const nextGameNumber = gameNumber + 1;
                            setGameNumber(nextGameNumber);
                            
                            // Track the start of the next game
                            if (firebaseDocId) {
                              try {
                                const { trackGameStart } = await import('./utils/firebaseSubmission');
                                await trackGameStart(nextGameNumber, firebaseDocId, currentLanguage);
                              } catch (error) {
                                console.error('Failed to track next game start:', error);
                              }
                            }
                            
                            handlePlayAgain(true); 
                            window._failedMissionPlayed = false; 
                            window._reachedLevelTracked = false;
                            setShowUserDataForm(false);
                            setFormCompletedThisGame(false); // Reset flag for next game
                            // Don't clear userData - keep it for pre-populating next game's form
                          }}
                          isScMode={isScMode}
                        />
                      </div>
                    </Html>
                  );
                }
              })()
            )}
            {/* User Data Collection Form */}
            {showUserDataForm && (
              <Html center style={{ zIndex: 4000 }}>
                <div className="ui-overlay congrats full-height-reached-level mobile-font-reduce fade-in">
                  <UserDataForm
                    level={hits + 1}
                    misses={totalAttempts - totalCakeHits}
                    gameNumber={gameNumber}
                    sessionScore={sessionScore + (hits + 1)}
                    sessionMisses={sessionMisses + (totalAttempts - totalCakeHits)}
                    firebaseDocId={firebaseDocId}
                    initialUserData={userData} // Pass previous user data to pre-populate
                    currentLanguage={currentLanguage}
                    translationFunction={t}
                    onComplete={(data) => {
                      // Save user data including privacy consent for future games
                      setUserData({
                        ...data,
                        privacyAccepted: true // Save that privacy was accepted
                      });
                      setFormCompletedThisGame(true); // Mark form as completed for this game
                      // Update session totals after completion
                      setSessionScore(prev => prev + (hits + 1));
                      setSessionMisses(prev => prev + (totalAttempts - totalCakeHits));
                      setShowUserDataForm(false);
                    }}
                    onSkip={() => {
                      setUserData({}); // Set empty object to indicate form was skipped
                      setFormCompletedThisGame(true); // Mark form as completed (skipped) for this game
                      // Update session totals even if skipped
                      setSessionScore(prev => prev + (hits + 1));
                      setSessionMisses(prev => prev + (totalAttempts - totalCakeHits));
                      setShowUserDataForm(false);
                    }}
                  />
                </div>
              </Html>
            )}
            {/* Logo and Attribution for Score Preview Screen */}
            {showRetryPrompt && attempts >= maxAttempts && !showUserDataForm && (
              <>
                {/* PLD Space Logo - Top Left (Desktop) / Top Center (Mobile) */}
                <Html style={{ pointerEvents: 'auto', zIndex: 10000 }}>
                  <a
                    href={isScMode ? undefined : "https://www.pldspace.com/"}
                    target={isScMode ? undefined : "_blank"}
                    rel="noopener noreferrer"
                    className="dsl-logo-desktop dsl-logo-score-preview-mobile"
                    onClick={isScMode ? undefined : () => track('CLICK_PLD_LOGO_DESKTOP')}
                    style={isScMode ? { pointerEvents: 'none' } : undefined}
                  >
                    <img
                      src="/images/PLDSpace_Logo_White.svg"
                      alt="PLD Space Logo"
                      className="dsl-logo-img-desktop"
                    />
                  </a>
                </Html>
                {/* Dark Star Labs Attribution - Bottom Left (Desktop) / Bottom Center (Mobile) */}
                <Html style={{ pointerEvents: 'auto', zIndex: 10000 }}>
                  <div className="dsl-attribution dsl-attribution-score-preview-mobile">
                    <a
                      href={isScMode ? undefined : "https://www.darkstarlabs.io/"}
                      target={isScMode ? undefined : "_blank"}
                      rel="noopener noreferrer"
                      onClick={isScMode ? undefined : () => track('CLICK_DARK_STAR_LABS')}
                      style={isScMode ? { pointerEvents: 'none' } : undefined}
                    >
                      <div className="powered-by-text">Powered by</div>
                      <div className="dark-star-labs-text">DARK STAR <span className="labs-red">LABS</span></div>
                    </a>
                  </div>
                </Html>
              </>
            )}
            {/* Congratulations UI Overlay */}
            {gameComplete && !showRetryPrompt && hasZoomed && (
              <Html center style={{ zIndex: 3000 }}>
                <div className="ui-overlay congrats mobile-font-reduce fade-in">
                  <div className="congrats-message">{t('gameUI.levelComplete')}</div>
                  <div className="ui-congrats-attempts">
                    {t('gameUI.hitCakeMessage').split('{attempts}')[0]}
                    <span className="ui-congrats-attempts">{attempts}</span>
                    {t('gameUI.hitCakeMessage').split('{attempts}')[1].replace('{plural}', attempts === 1 ? '' : 's')}
                  </div>
                  <button className="ui-congrats-btn" onClick={async () => { 
                    playUIButtonSound(); 
                    
                    // Track level completion before moving to next level
                    if (firebaseDocId) {
                      try {
                        const { trackLevelCompletion } = await import('./utils/firebaseSubmission');
                        // Calculate current session totals (including this level)
                        const currentSessionScore = sessionScore + (hits + 1);
                        const currentSessionMisses = sessionMisses + (totalAttempts - totalCakeHits);
                        await trackLevelCompletion(
                          firebaseDocId, 
                          gameNumber, 
                          hits + 1, 
                          totalAttempts - totalCakeHits,
                          currentSessionScore,
                          currentSessionMisses
                        );
                      } catch (error) {
                        console.error('Failed to track level completion:', error);
                      }
                    }
                    
                    handlePlayAgain(false); 
                    track('NEXT_LEVEL'); 
                  }}>{t('gameUI.nextLevel')}</button>
                </div>
              </Html>
            )}
            {attempts >= maxAttempts && !showRetryPrompt && null}
            {gameComplete && !hasZoomed && (
              <CameraZoomOnComplete
                gameComplete={gameComplete}
                resetCounter={resetCounter}
                onZoomEnd={() => {
                  setHasZoomed(true);
                  // Play mission success audio
                  playAudio('/audio/sfx/UI_MissionSuccess_01.mp3', { volume: 0.35 });
                }}
              />
            )}
            <FovResetter trigger={forceFovReset} onReset={() => setForceFovReset(false)} />
              <EffectComposer>
                <Bloom luminanceThreshold={0.25} luminanceSmoothing={1} intensity={1} kernelSize={KernelSize.LARGE} mipmapBlur={true} resolutionX={Resolution.AUTO_SIZE} resolutionY={Resolution.AUTO_SIZE}/>
              </EffectComposer>
            <Preload all />

          </Canvas>
        </>
      )}
      <SpaceComm />
    </>
  );
}

// Utility to play a random UI button sound
function playUIButtonSound() {
  const which = Math.random() < 0.5 ? '01' : '02';
  playAudio(`/audio/sfx/UI_Buttons_${which}.mp3`, { volume: 0.5 });
}

function CameraZoomOnComplete({ gameComplete, resetCounter, onZoomEnd }) {
  const { camera } = useThree();
  useEffect(() => {
    // Reset FOV immediately on reset
    camera.fov = 75;
    camera.updateProjectionMatrix();
  }, [resetCounter, camera]);
  useEffect(() => {
    if (gameComplete) {
      // Animate FOV to zoom in
      let frame;
      const startFov = camera.fov;
      const endFov = 15;
      const duration = 0.7; // seconds
      const start = performance.now();
      function easeInOutCubic(x) {
        return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
      }
      function animate(now) {
        let t = Math.min(1, (now - start) / (duration * 1000));
        t = easeInOutCubic(t);
        camera.fov = startFov + (endFov - startFov) * t;
        camera.updateProjectionMatrix();
        if (t < 1) {
          frame = requestAnimationFrame(animate);
        } else if (onZoomEnd) {
          onZoomEnd();
        }
      }
      frame = requestAnimationFrame(animate);
      return () => cancelAnimationFrame(frame);
    }
  }, [gameComplete, camera, onZoomEnd]);
  return null;
}

// Forces camera FOV to 75 when trigger changes
function FovResetter({ trigger, onReset }) {
  const { camera } = useThree();
  useEffect(() => {
    if (trigger) {
      camera.fov = 75;
      camera.updateProjectionMatrix();
      if (onReset) onReset();
    }
  }, [trigger, camera, onReset]);
  return null;
}
